import { Button, ErrorContainer } from 'components';
import { useFormikContext } from 'formik';
import { isAiScribeRecordingStatus, openAiScribeDrawer } from 'store/aiScribe/aiScribeSlice';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { hideNoteModal } from 'store/noteModal/noteModalSlice';

import { useNoteFormContext } from '../context/noteFormContext';
import { NoteFormValues, remapValues, removeEmptyFieldsFromObject } from '../utils';

export const AiScribeButton = () => {
  const aiScribe = useAppSelector((state) => state.aiScribe);
  const dispatch = useAppDispatch();
  const { clientName, prependedClientId, clientId, onOpenAiScribeDrawer } = useNoteFormContext();
  const formik = useFormikContext<NoteFormValues>();

  const onRecord = () => {
    dispatch(
      openAiScribeDrawer({
        clientId: Number(clientId),
        clientName: clientName,
        prependedClientId: prependedClientId,
        note: removeEmptyFieldsFromObject(remapValues({ values: formik.values }))
      })
    );
    dispatch(hideNoteModal());

    onOpenAiScribeDrawer?.();
  };

  return (
    <>
      <Button
        text="Record"
        theme="primary"
        icon={<span className="material-icons">mic</span>}
        handleOnClick={onRecord}
        type="button"
        disabled={isAiScribeRecordingStatus(aiScribe.status)}
      />
      <ErrorContainer
        errors={formik.errors}
        visible={formik.touched?.note && formik.errors?.note}
        name="test"
      />
    </>
  );
};
